var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconscheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.96 2.06008L5.46005 4.12008C4.41005 4.52008 3.55005 5.76008 3.55005 6.89008V14.9901C3.55005 15.8001 4.08005 16.8701 4.73005 17.3501L10.23 21.4601C11.2 22.1901 12.79 22.1901 13.76 21.4601L19.26 17.3501C19.91 16.8601 20.4401 15.8001 20.4401 14.9901V6.89008C20.4401 5.77008 19.58 4.52008 18.53 4.13008L13.03 2.07008C12.47 1.85008 11.53 1.85008 10.96 2.06008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.66 14.2301C10.47 14.2301 10.28 14.1601 10.13 14.0101L8.51999 12.4001C8.22999 12.1101 8.22999 11.6301 8.51999 11.3401C8.80999 11.0501 9.28999 11.0501 9.57999 11.3401L10.66 12.4201L14.43 8.65012C14.72 8.36012 15.2 8.36012 15.49 8.65012C15.78 8.94012 15.78 9.42012 15.49 9.71012L11.19 14.0101C11.04 14.1601 10.85 14.2301 10.66 14.2301Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconscheck);
export default __webpack_public_path__ + "static/media/Iconscheck.45b63843578554461dac4f10c8d95f61.svg";
export { ForwardRef as ReactComponent };